/**
 * Events & Insights Archive AJAX
 * Handles AJAX filtering and pagination
 */

(function($) {
    'use strict';

    const ArchiveAjax = {
        $form: null,
        $content: null,
        $pagination: null,
        isLoading: false,

        init: function() {
            this.$form = $('#archive-filters-form');
            this.$content = $('.archive-content');
            this.$pagination = $('.archive-pagination');

            if (!this.$form.length || !this.$content.length) {
                return;
            }

            this.bindEvents();
        },

        bindEvents: function() {
            // Form submission
            this.$form.on('submit', (e) => {
                e.preventDefault();
                this.loadResults(1);
            });

            // Filter checkboxes and radio buttons - auto submit
            this.$form.on('change', 'input[type="checkbox"], input[type="radio"]', () => {
                this.loadResults(1);
            });
            
            // Toggle location filter visibility based on type selection
            this.$form.on('change', 'input[name="type"]', (e) => {
                const $locationFilter = $('.location-filter-group');
                const $yearFilter = $('.year-filter-group');
                const selectedType = e.target.value;
                
                if (selectedType === 'post') {
                    // Hide location filter for insights
                    $locationFilter.slideUp(300);
                    // Show year filter for insights
                    $yearFilter.slideDown(300);
                } else {
                    // Show location filter for events
                    $locationFilter.slideDown(300);
                    // Hide year filter for events
                    $yearFilter.slideUp(300);
                }
            });
            
            // Set initial state on page load
            const initialType = this.$form.find('input[name="type"]:checked').val();
            if (initialType === 'post') {
                $('.location-filter-group').hide();
                $('.year-filter-group').show();
            } else {
                $('.location-filter-group').show();
                $('.year-filter-group').hide();
            }
            
            // Check if any filters are active on page load
            this.updateClearButtonVisibility();
            
            // Update clear button visibility on any filter change
            this.$form.on('change', 'input', () => {
                this.updateClearButtonVisibility();
            });

            // Search input - debounced
            let searchTimeout;
            this.$form.on('input', '.filter-search-input', () => {
                clearTimeout(searchTimeout);
                searchTimeout = setTimeout(() => {
                    this.loadResults(1);
                }, 500);
                // Update button visibility on search input
                this.updateClearButtonVisibility();
            });

            // Pagination clicks
            $(document).on('click', '.archive-pagination a', (e) => {
                e.preventDefault();
                const url = new URL(e.currentTarget.href);
                const page = url.searchParams.get('paged') || 1;
                this.loadResults(page);
            });

            // Clear filters button
            this.$form.on('click', '.btn-clear-filters', (e) => {
                e.preventDefault();
                // Explicitly uncheck all checkboxes
                this.$form.find('input[type="checkbox"]').prop('checked', false);
                // Reset type toggle to event (default)
                this.$form.find('input[name="type"][value="event"]').prop('checked', true);
                // Clear search input
                this.$form.find('input[type="search"]').val('');
                // Reload results
                this.loadResults(1);
                // Hide button after clearing
                this.updateClearButtonVisibility();
            });
        },

        loadResults: function(page = 1) {
            if (this.isLoading) {
                return;
            }

            this.isLoading = true;
            
            // Scroll to top of results
            $('html, body').animate({
                scrollTop: this.$content.offset().top - 100
            }, 400);
            
            // Fade out current results
            this.fadeOutResults(() => {
                // Show loading state after fade out
                this.showLoading();

                const formData = new FormData(this.$form[0]);
                formData.append('action', 'filter_events_insights');
                formData.append('paged', page);

                // Convert FormData to URLSearchParams for better handling
                const params = new URLSearchParams();
                for (const [key, value] of formData.entries()) {
                    params.append(key, value);
                }

                $.ajax({
                    url: caliewp_ajax.ajax_url,
                    type: 'POST',
                    data: params.toString(),
                    dataType: 'json',
                    success: (response) => {
                        if (response.success) {
                            this.updateResults(response.data);
                            this.updateURL(page);
                        } else {
                            this.showError(response.data?.message || 'An error occurred.');
                        }
                    },
                    error: (xhr, status, error) => {
                        console.error('AJAX Error:', error);
                        this.showError('Failed to load results. Please try again.');
                    },
                    complete: () => {
                        this.isLoading = false;
                        this.hideLoading();
                    }
                });
            });
        },

        updateResults: function(data) {
            // Update the content
            if (data.html) {
                this.$content.html(data.html);
                
                // Re-initialize filter toggles after content update
                // (they don't need re-binding since they're in the sidebar which doesn't change)
                
                // Fade in new results
                this.fadeInResults();
            }

            // Update pagination reference
            this.$pagination = this.$content.find('.archive-pagination');
        },

        fadeOutResults: function(callback) {
            const $resultsGrid = this.$content.find('.archive-results-grid, .no-results, .archive-error');
            const $pagination = this.$content.find('.archive-pagination');
            
            if ($resultsGrid.length || $pagination.length) {
                $resultsGrid.add($pagination).css({
                    'opacity': '1',
                    'transition': 'opacity 0.3s ease-out'
                }).animate({
                    opacity: 0
                }, 300, function() {
                    if (callback) callback();
                });
            } else {
                if (callback) callback();
            }
        },

        fadeInResults: function() {
            const $resultsGrid = this.$content.find('.archive-results-grid, .no-results, .archive-error');
            const $pagination = this.$content.find('.archive-pagination');
            
            $resultsGrid.add($pagination).css({
                'opacity': '0',
                'transition': 'opacity 0.4s ease-in'
            });
            
            // Force reflow
            $resultsGrid[0]?.offsetHeight;
            
            setTimeout(() => {
                $resultsGrid.add($pagination).css('opacity', '1');
            }, 50);
        },

        updateURL: function(page) {
            // Update URL without page reload for better UX
            const formData = new FormData(this.$form[0]);
            const type = formData.get('type') || 'event';
            
            // Build pretty URL base
            let basePath = '/events-insights/';
            if (type === 'event') {
                basePath += 'events/';
            } else if (type === 'post') {
                basePath += 'insights/';
            }
            
            // Add pagination to path if needed
            if (page > 1) {
                basePath += `page/${page}/`;
            }
            
            // Add other filters as query params
            const params = new URLSearchParams();
            for (const [key, value] of formData.entries()) {
                if (value && key !== 'type') { // Exclude type since it's in the URL path
                    params.append(key, value);
                }
            }
            
            const newURL = params.toString() 
                ? `${basePath}?${params.toString()}`
                : basePath;
            
            history.pushState({}, '', newURL);
        },

        showLoading: function() {
            this.$content.addClass('loading');
            
            // Add loading overlay if it doesn't exist
            if (!this.$content.find('.loading-overlay').length) {
                const $overlay = $('<div class="loading-overlay"><div class="loading-spinner"></div></div>');
                $overlay.css('opacity', '0');
                this.$content.append($overlay);
                
                // Fade in loading overlay
                setTimeout(() => {
                    $overlay.css({
                        'transition': 'opacity 0.2s ease-in',
                        'opacity': '1'
                    });
                }, 10);
            }
        },

        hideLoading: function() {
            const $overlay = this.$content.find('.loading-overlay');
            
            if ($overlay.length) {
                $overlay.css({
                    'transition': 'opacity 0.2s ease-out',
                    'opacity': '0'
                });
                
                setTimeout(() => {
                    this.$content.removeClass('loading');
                    $overlay.remove();
                }, 200);
            } else {
                this.$content.removeClass('loading');
            }
        },

        showError: function(message) {
            const errorHtml = `
                <div class="archive-error">
                    <p>${message}</p>
                    <button class="btn-retry">Try Again</button>
                </div>
            `;
            this.$content.html(errorHtml);
            
            // Bind retry button
            this.$content.on('click', '.btn-retry', () => {
                this.loadResults(1);
            });
        },
        
        updateClearButtonVisibility: function() {
            const $clearButton = $('.btn-clear-filters');
            let hasActiveFilters = false;
            
            // Check if search has value
            const searchValue = this.$form.find('.filter-search-input').val();
            if (searchValue && searchValue.trim() !== '') {
                hasActiveFilters = true;
            }
            
            // Check if any checkboxes are checked (excluding type toggle)
            const $checkedCheckboxes = this.$form.find('input[type="checkbox"]:checked');
            if ($checkedCheckboxes.length > 0) {
                hasActiveFilters = true;
            }
            
            // Show or hide the clear button with simple fade
            if (hasActiveFilters) {
                $clearButton.fadeIn(200);
            } else {
                $clearButton.fadeOut(200);
            }
        }
    };

    // Mobile filters toggle
    const MobileFilters = {
        init: function() {
            this.$toggle = $('.mobile-filters-toggle');
            this.$panel = $('.filters-panel');
            
            if (!this.$toggle.length || !this.$panel.length) {
                return;
            }
            
            this.bindEvents();
        },
        
        bindEvents: function() {
            this.$toggle.on('click', () => {
                this.togglePanel();
            });
        },
        
        togglePanel: function() {
            const isExpanded = this.$toggle.attr('aria-expanded') === 'true';
            
            if (isExpanded) {
                this.$toggle.attr('aria-expanded', 'false');
                this.$panel.slideUp(300);
                this.$toggle.removeClass('expanded');
            } else {
                this.$toggle.attr('aria-expanded', 'true');
                this.$panel.slideDown(300);
                this.$toggle.addClass('expanded');
            }
        }
    };

    // Initialize on document ready
    $(document).ready(function() {
        ArchiveAjax.init();
        MobileFilters.init();
    });

})(jQuery);

